const breadCrumb = "Lançamento de Notas - Ranking de Desempenho Acadêmico";

const routes = [
  {
    path: "/gerar-ranking-de-desempenho-academico",
    name: "gerar-ranking-de-desempenho-academico",
    meta: {
      requireAuth: false,
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/GerarRankingDeDesempenhoAcademicoGeral/GerarRankingDeDesempenhoAcademicoGeral.vue"
      ),
  },
];

export default routes;
